import s from './ProgressBar.module.css';

export default function ProgressBar({ value = 0, max = 100, className = '', ...rest }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div
      className={`${s.track} ${className}`.trim()}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      {...rest}
    >
      <div className={s.fill} style={{ width: `${pct}%` }} />
    </div>
  );
}
